import { Media } from 'media'
import { ComponentType } from 'react'
import { FilterDesktop } from './filter-desktop'
import { FilterMobile } from './filter-mobile'

interface Props {
  label: string
  disabled?: boolean
  isOpen: boolean
  isActive: boolean
  onToggle: () => void
}

export const Filter: ComponentType<Props> = props => (
  <>
    <Media at="xs">
      <FilterMobile {...props} />
    </Media>
    <Media greaterThan="xs">
      <FilterDesktop {...props} />
    </Media>
  </>
)
